"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

/**
 * операторы и их коды
 */
var _operators = {
  mts: [/^\+380(50|66|95|99)\d{7}$/],
  kyivstar: [/^\+380(67|96|97|98)\d{7}$/],
  peoplenet: [/^\+380(92)\d{7}$/],
  beeline: [/^\+380(68)\d{7}$/],
  life: [/^\+380(63|93|73)\d{7}$/],
  utel: [/^\+380(91)\d{7}$/],
  vegaTelecom: [/^(\+38)?(056371)\d{4}$/],
  goldenTelecom: [/^\+380(39)\d{7}$/],
  intertelecom: [/^\+?380(11|13|15|20|41|64|65|69|94|3[1-8]|4[35-8]|5[1-7]|62)/, /^\+?38044222[5000-9999]/, /^\+?38044221[0000-9999]/, /^\+?3804433[10000-29999]/, /^\+?3804433[70000-89999]/, /^\+?3804435[30000-39999]/, /^\+?38044451[5000-7999]/, /^\+?38044587[5000-9999]/, /^\+?38044592[0000-9999]/, /^\+?380445371[000-999]/, /^\+?38044223[0000-9999]/, /^\+?3804435[50000-89999]/, /^\+?38044599[0000-9999]/, /^\+?3804422[70000-99999]/, /^\+?3804499[00000-99999]/, /^\+?3804427799[00-99]/, /^\+?3804436[00000-29999]/, /^\+?3804438[30000-49999]/, /^\+?38044630[7000-9999]/, /^\+?380446599[000-999]/, /^\+?380447192[000-999]/, /^\+?380447369[000-999]/, /^\+?3804435[30000-39999]/, /^\+?3806170[70000-99999]/, /^\+?3806199[00000-99999]/, /^\+?38061701[0000-6999]/, /^\+?38061220[1000-3999]/, /^\+?38061270[0000-1999]/, /^\+?38061220[7000-8999]/, /^\+?38061270[4000-9999]/],
  veltonTelecom: [/^(\+38)?057/],
  ukrTelecom: [/^(\+38)?(044|061)\d{7}$/],
  test: [/^(\+38)?0001111111/],
  lycamobile: [/^\+?380916[0-9]{5}/]
},
    _masks = {
  fullFormat: /^(\+[0-9]{12})$/,
  // +00 (000) 000 00 00 (только на Украину)
  shortFormat: /^[0-9]{10}$/,
  // (000) 000 00 00,
  fullAllFormat: /^(\+[0-9]{7,13})$/
};

var IPhone =
/*#__PURE__*/
function () {
  function IPhone(number) {
    (0, _classCallCheck2["default"])(this, IPhone);
    this.value = number;
    return this;
  }

  (0, _createClass2["default"])(IPhone, [{
    key: "isUkrTelecomPhone",

    /**
     * @return {Boolean}
     */
    value: function isUkrTelecomPhone() {
      return this._isFoundInOperatorsList(_operators.ukrTelecom) && !this.isInterTelecom();
    }
    /**
     * @return {Boolean}
     */

  }, {
    key: "isMobile",
    value: function isMobile() {
      return this.isMtsPhone() || this.isKyivStarPhone() || this.isPeopleNetPhone() || this.isLifePhone() || this.isInterTelecom() || this.isUtelPhone() || this.isVeltonTelecom();
    }
    /**
     * Проверка формата телефона на соответствие +380******
     * @return {boolean}
     */

  }, {
    key: "isUkrPhone",
    value: function isUkrPhone() {
      return /^\+380/i.test(this.value);
    }
  }, {
    key: "isRussianPhone",
    value: function isRussianPhone() {
      return /^\+7/i.test(this.value);
    }
    /**
     * @return {boolean}
     */

  }, {
    key: "isMtsPhone",
    value: function isMtsPhone() {
      return this._isFoundInOperatorsList(_operators.mts);
    }
    /**
     * @return {boolean|*}
     */

  }, {
    key: "isKyivStarPhone",
    value: function isKyivStarPhone() {
      return this._isFoundInOperatorsList(_operators.kyivstar) || this.isBeelinePhone() || this.isGoldenTelecom();
    }
    /**
     * @return {boolean}
     */

  }, {
    key: "isPeopleNetPhone",
    value: function isPeopleNetPhone() {
      return this._isFoundInOperatorsList(_operators.peoplenet);
    }
    /**
     * @return {boolean}
     */

  }, {
    key: "isBeelinePhone",
    value: function isBeelinePhone() {
      return this._isFoundInOperatorsList(_operators.beeline);
    }
    /**
     * @return {boolean}
     */

  }, {
    key: "isLifePhone",
    value: function isLifePhone() {
      return this._isFoundInOperatorsList(_operators.life);
    }
    /**
     * @return {boolean}
     */

  }, {
    key: "isUtelPhone",
    value: function isUtelPhone() {
      return this._isFoundInOperatorsList(_operators.utel);
    }
    /**
     * @return {boolean}
     */

  }, {
    key: "isInterTelecom",
    value: function isInterTelecom() {
      return this._isFoundInOperatorsList(_operators.intertelecom);
    }
    /**
     * @return {boolean}
     */

  }, {
    key: "isVeltonTelecom",
    value: function isVeltonTelecom() {
      return this._isFoundInOperatorsList(_operators.veltonTelecom);
    }
    /**
     * @return {boolean}
     */

  }, {
    key: "isGoldenTelecom",
    value: function isGoldenTelecom() {
      return this._isFoundInOperatorsList(_operators.goldenTelecom);
    }
  }, {
    key: "isLycaMobile",
    value: function isLycaMobile() {
      return this._isFoundInOperatorsList(_operators.lycamobile);
    }
    /**
     * @description For ex. +38097
     * @return {string}
     */

  }, {
    key: "getPhonePrefix",
    value: function getPhonePrefix() {
      return this.toFullFormat().substring(0, 6);
    }
    /**
     * Проверка формата телефона (Украина) на соответствие +*********
     * @return {boolean}
     */

  }, {
    key: "isFullFormat",
    value: function isFullFormat() {
      return this.value && _masks.fullFormat.test(this.value) && this.isUkrPhone();
    }
    /**
     * Проверка формата телефона (Украина, Россия, США) на соответствие +*********
     * @return {*}
     */

  }, {
    key: "isFullFormatAll",
    value: function isFullFormatAll() {
      return this.value && _masks.fullAllFormat.test(this.value);
    }
    /**
     * @param {string} format
     * @return {boolean}
     * - full(+38 000 111 22 33)
     * - short (+38 000 111 22 33)
     * - full-all - полный формат, любые номера (Украина, Россия, Америка)
     */

  }, {
    key: "validate",
    value: function validate() {
      var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'full-all';

      if (format === 'full') {
        return this.isFullFormat();
      }

      if (format === 'full-all') {
        return this.isFullFormatAll();
      }

      return !!this.value;
    }
    /**
     * For example, +380931112233, this function return 1112233
     * @return {*}
     */

  }, {
    key: "getPhoneNumber",
    value: function getPhoneNumber() {
      return this.isMobile() ? this.toFullFormat().substring(6) : this.value;
    }
    /**
     * For example, +380931112233, this function return 0931112233
     * @return {string}
     */

  }, {
    key: "toShortFormat",
    value: function toShortFormat() {
      return this.toFullFormat().substring(3);
    }
    /**
     * For example, +380931112233, this function return 093
     * @return {string}
     */

  }, {
    key: "getPhoneOperator",
    value: function getPhoneOperator() {
      return this.toFullFormat().substring(3, 6);
    }
    /**
     * Возвращает полный номер без знака +
     * @return {string}
     */

  }, {
    key: "getOnlyNumber",
    value: function getOnlyNumber() {
      return this.toFullFormat().replace(/[\D]+/g, '');
    }
    /**
     * @return {*}
     */

  }, {
    key: "getUkrPhoneOperator",
    value: function getUkrPhoneOperator() {
      if (this.value) {
        var i,
            j,
            len,
            number = this.toFullFormat(); // переберем всех операторов

        for (i in _operators) {
          // вернем название оператора в случае совпадения кода
          if (_operators.hasOwnProperty(i)) {
            len = _operators[i].length;

            for (j = len - 1; j >= 0; j--) {
              if (_operators[i][j].test(number)) {
                return i;
              }
            }
          }
        }
      }

      return '';
    }
    /**
     * return phone in format +380931112233, +79015010000
     * @return {string}
     */

  }, {
    key: "toFullFormat",
    value: function toFullFormat() {
      return this.value;
    }
  }, {
    key: "toPatternFormat",
    value: function toPatternFormat(format) {
      if (!this.value) return '';
      var number = this.toFullFormat(),
          len = number.length,
          i = 0;
      if (!format || typeof format !== 'string') return number;

      for (i; i < len; i++) {
        if (number[i] !== '+') {
          format = format.replace(/[x]{1}/i, number[i]);
        }
      }

      format = format.replace(/x+/gi, '');
      return format.trim();
    }
  }, {
    key: "toContactFormat",
    value: function toContactFormat() {
      if (this.isUkrPhone()) {
        return this.toPatternFormat('+xx (xxx) xxx xx xx');
      } else if (this.isRussianPhone()) {
        return this.toPatternFormat('+x (xxx) xxx xx xx');
      } else {
        return this.toPatternFormat('+xxx xxx xxx xxx xxx');
      }
    }
    /**
     * @param {string} format
     * @return {string}
     */

  }, {
    key: "toString",
    value: function toString(format) {
      if (format === 'short') {
        return this.toShortFormat();
      } else if (format === 'contact') {
        return this.toContactFormat(); //    has X placeholders
      } else if (/[x]+/.test(format)) {
        return this.toPatternFormat(format);
      }

      return this.value;
    }
    /**
     * @param {*} value
     * @return {boolean}
     */

  }, {
    key: "is",
    value: function is(value) {
      return this.toString() === new IPhone(value).toString();
    }
    /**
     * @param {Array} list
     * @return {boolean}
     * @private
     */

  }, {
    key: "_isFoundInOperatorsList",
    value: function _isFoundInOperatorsList(list) {
      var result = false;

      if (this.value && list) {
        var number = this.toFullFormat(),
            numberWithoutCountryCode = number.substring(4),
            numberWithoutPlus = number.replace(/\+/, '');
        result = !!list.find(function (operator) {
          return operator.test(number) || operator.test(numberWithoutPlus) || operator.test(numberWithoutCountryCode);
        });
      }

      return result;
    }
  }, {
    key: "toHtml",
    value: function toHtml() {
      var _this$toString;

      window.console.warn('IPhone prototype.toHtml() is deprecated. Use .toString()');

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return (_this$toString = this.toString).apply.apply(_this$toString, [this].concat(args));
    }
  }, {
    key: "find",
    value: function find() {
      window.console.warn('IPhone prototype.find() is deprecated.');
      return false;
    }
  }, {
    key: "isDefault",
    value: function isDefault() {
      window.console.warn('IPhone prototype.isDefault() is deprecated.');
      return false;
    }
    /**
     * @return {Boolean}
     */

  }, {
    key: "isUkrainianTownPhone",
    value: function isUkrainianTownPhone() {
      window.console.warn('IPhone prototype.isUkrainianTownPhone() is deprecated.');
      return false;
    }
  }, {
    key: "value",
    get: function get() {
      return this._value === null ? '' : this._value;
    },
    set: function set(value) {
      value = value instanceof IPhone ? value.toString() : value;

      if (typeof value === 'number') {
        value = String(value);
      } // Для украинских телефонов


      if (value && typeof value === 'string' && value[0] === '0' && value.length === 10) {
        value = '+38' + value;
      }

      if (value && typeof value === 'string') {
        value = '+' + value.replace(/\D+/g, '');
      }

      if (!value) {
        value = null;
      }

      this._value = value;
    }
  }]);
  return IPhone;
}();

var _default = IPhone;
exports["default"] = _default;